export default __webpack_public_path__ + "Domine-Regular.ttf";